<template>
    <div id="vueApp">
        <Header ref="header" :showLinks="showHeader" :mode="headerMode" />
        <router-view ref="view" v-bind:class="[policyVisible || shipRecyclingVisible ? 'lower' : '']"
            v-on:togglePolicy="togglePolicy" v-on:toggleShipRecycling="toggleShipRecycling"
            :policy-visible="policyVisible" :ship-recycling-visible="shipRecyclingVisible"></router-view>
        <Footer ref="footer" v-show="showFooter" v-on:togglePolicy="togglePolicy"
            v-on:toggleShipRecycling="toggleShipRecycling"
            v-bind:class="[policyVisible || shipRecyclingVisible ? 'lower' : '']" />
        <b-overlay :show="showLoading" variant="dark" z-index="2000" no-wrap class="position-fixed">
            <template #overlay>
                <i class="fa fa-ship fa-fade loading-icon"></i>
            </template>
        </b-overlay>
    </div>
</template>

<script>
import VueRouter from 'vue-router';
// Public app
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import Main from "./components/Main.vue";
import Press from "./components/Press.vue";
import Careers from "./components/Careers.vue";
// Admin app
import LogIn from "./components/admin/LogIn.vue";
import EditAboutUs from "./components/admin/EditAboutUs.vue";
import EditFleetByType from "./components/admin/EditFleetByType.vue";
import EditNumbers from "./components/admin/EditNumbers.vue";
import EditMembers from "./components/admin/EditMembers.vue";
import EditClients from "./components/admin/EditClients.vue";
import EditContacts from "./components/admin/EditContacts.vue";
import EditPolicy from "./components/admin/EditPolicy.vue";
import EditCareers from "./components/admin/EditCareers.vue";
import EditPress from "./components/admin/EditPress.vue";

const routes = [
    // Admin app
    { path: '/admin/about', component: EditAboutUs },
    { path: '/admin/fleet', component: EditFleetByType },
    { path: '/admin/numbers', component: EditNumbers },
    { path: '/admin/members', component: EditMembers },
    { path: '/admin/clients', component: EditClients },
    { path: '/admin/contacts', component: EditContacts },
    { path: '/admin/policy', component: EditPolicy },
    { path: '/admin/press', component: EditPress },
    { path: '/admin/careers', component: EditCareers },
    { path: '/admin', component: LogIn },
    { path: '/admin/*', redirect: '/admin' },
    // Public app
    { path: '/home/:angkor', component: Main },
    { path: '/press', component: Press },
    { path: '/careers', component: Careers },
    { path: '/', component: Main },
    { path: '/*', redirect: '/' }
];

const router = new VueRouter({
    routes
});

export default {
    name: 'App',
    components: {
        Header,
        Footer
    },
    router,
    data() {
        return {
            policy: false,
            shipRecycling: false,
            headerMode: "public",
            showHeader: true,
            showFooter: true,
            showLoading: true,
            main: null
        }
    },
    computed: {
        policyVisible() {
            return this.policy;
        },
        shipRecyclingVisible() {
            return this.shipRecycling;
        }
    },
    watch: {
        $route: function (route) {
            this.headerFooter(route);
        },
        '$store.state.about': function () {
            if (this.$store.state.about && this.$store.state.about.length > 0) {
                this.showLoading = false;
                this.main.classList.remove("loading");
            } else {
                this.showLoading = true;
                this.main.classList.add("loading");
            }
        }
    },
    methods: {
        toggleFooter(ev) {
            ev.preventDefault();

            let shipRecycling = this.$refs.view.$refs.shipRecycling,
                shipRecyclingEl;
            let policy = this.$refs.view.$refs.policy,
                policyEl;

            if (shipRecycling) {
                shipRecyclingEl = shipRecycling.$el;
                shipRecyclingEl.scrollTo(0, 0);
            }

            if (policy) {
                policyEl = policy.$el;
                policyEl.scrollTo(0, 0);
            }
        },
        togglePolicy(ev) {
            this.toggleFooter(ev);

            if (this.shipRecycling) {
                this.shipRecycling = false;
            }

            this.policy = !this.policy;
        },
        toggleShipRecycling(ev) {
            this.toggleFooter(ev);

            if (this.policy) {
                this.policy = false;
            }

            this.shipRecycling = !this.shipRecycling;
        },
        headerFooter(route) {
            if (route.path === "/admin") {
                this.showHeader = false;
                this.showFooter = false;
            } else if (route.path.indexOf("/admin/") > -1) {
                this.headerMode = "admin";
                this.showHeader = true;
                this.showFooter = false;
            } else {
                this.headerMode = "public";
                this.showHeader = true;
                this.showFooter = true;
            }
        }
    },
    mounted() {
        this.headerFooter(this.$route);

        this.main = this.$el.querySelector(".main");

        if (!this.$store.state.about || this.$store.state.about.length === 0) {
            this.showLoading = true;
            this.main.classList.add("loading");
        } else {
            this.showLoading = false;
            this.main.classList.remove("loading");
        }
    }
}
</script>

<style scoped>
@keyframes opacity {

    0%,
    100% {
        opacity: 0;
    }

    50% {
        opacity: 1;
    }
}

@keyframes zoom {
    0% {
        transform: scale(1, 1);
    }

    50% {
        transform: scale(1.5, 1.5);
    }

    100% {
        transform: scale(1, 1);
    }
}

.loading-icon {
    font-size: 5em;
    animation: zoom 2s infinite, opacity 2s infinite;
}
</style>